import React from 'react'

function Notification({ notifyData }) {
    return (
        <React.Fragment>
            <div className=" py-2 notification">
                <div className="flex items-center">
                    <div className="w-12 h-12 mr-2">
                        <a href={`http://wisemonkeys.info/${notifyData.username}`}>
                            <img src={notifyData.profile_photo} alt="" className="w-full h-full object-cover rounded-full mr-3" />
                        </a>
                    </div>
                    <div>
                        <div className="">
                            <a target="_blank" href={`http://wisemonkeys.info/${notifyData.username}`} className="text-sm font-medium mr-1 color-black manpro">{notifyData.full_name}</a>
                            <span className="text-sm manpro">{notifyData.message}</span>
                        </div>
                        {notifyData.title && <div className="text-left">
                            <a target="_blank" href={`http://wisemonkeys.info/${notifyData.type}/${notifyData.url}`} className="text-xs italic font-medium mr-1 color-black manpro wordClamp-note">{notifyData.title}</a>
                        </div>}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Notification
